var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17",
    width: 16,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .5a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm1.04 12.663a.285.285 0 0 0-.183.263v.503a.857.857 0 0 1-1.714 0v-.503a.275.275 0 0 0-.183-.263 2.87 2.87 0 0 1-1.783-2.286.857.857 0 0 1 1.062-.953.835.835 0 0 1 .618.747 1.147 1.147 0 0 0 2.286-.171.857.857 0 0 0-.526-.8L6.71 8.877A2.571 2.571 0 0 1 5.143 6.5 2.869 2.869 0 0 1 6.96 3.837a.286.286 0 0 0 .183-.263v-.503a.857.857 0 0 1 1.714 0v.503a.274.274 0 0 0 .183.263 2.869 2.869 0 0 1 1.783 2.286.857.857 0 0 1-1.062.953.834.834 0 0 1-.618-.747 1.146 1.146 0 0 0-2.286.171.857.857 0 0 0 .526.8l1.908.823a2.571 2.571 0 0 1 1.566 2.377 2.868 2.868 0 0 1-1.817 2.663Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCoin);
export default __webpack_public_path__ + "static/media/dollar-coin.6446100766bef4a40b96cb9d4a302d2a.svg";
export { ForwardRef as ReactComponent };